






























































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import AudioRecorder from "@/library/Recorders/AudioRecorder";
import VideoRecorder from "@/library/Recorders/VideoRecorder";
import SocketHandler from "@/library/OraiSocketHandler";
import { RecordIcon } from "@/components/Icons";
import { Getter, Action } from "vuex-class";
import { RecordInitiator, VideoCallBackData } from "@/types";
import { timerString, randomvideoloadinggif } from "@/utils";
import { RTPace, RTFiller } from "../../types/LearnerRecordings";

@Component({
  components: {
    RecordIcon,
    // VueDraggableResizable
  },
})
export default class Recorder extends Vue {
  @Prop({ default: "Exercise" }) private type!: string;
  @Prop() private exerciseID!: number;
  @Prop({ default: false }) private recordVideo!: boolean;
  @Prop({ default: 0 }) private reset!: Number;
  @Getter private JWT!: string;
  @Getter private UID!: string;
  @Action private setRecordedVideoURL!: any;
  private isRecording: boolean = false;
  private timeElapsed: number = 0;
  private timer: any;
  private ar?: AudioRecorder; // = new AudioRecorder(this.onAudioChunk);
  private vr!: VideoRecorder;
  private socket!: SocketHandler;
  private timerStr = timerString;
  private connectionEstablished: Boolean = false;
  private showWarning = false;
  private randomvideoloadinggif = randomvideoloadinggif;
  private havepermissions: Boolean = true;
  private popupMessage: String = "";
  private popupMessageSuccess: Boolean = false;
  private popupMessageTimeout?: number;

  private setupSocketHandlers() {
    this.socket = new SocketHandler(
      this.onResults,
      this.recordVideo ? "webrtc" : "pcm"
    );

    this.socket.setErrorCallback(this.fatalError);
    this.socket.onDisplayMessage = (msg: any) => {
      this.displayPopupMessage(msg["Message"], msg["Type"] === "success");
    };
    this.socket.onRTPace = (rtPace: RTPace) => {
      if (rtPace.Data) {
        this.$emit("rt-pace", rtPace.Data.Pace);
      }
    };
    this.socket.onRTFiller = (rtFiller: RTFiller) => {
      this.$emit("rt-filler", rtFiller.Data);
    };
  }

  private fatalError(ev: Event) {
    //this.cancelRecording();
    this.$emit("fail", ev);
    this.$emit("done-recording");
  }

  private toggleRecording() {
    if (!this.isRecording) {
      this.startRecording();
      return;
    }
    this.isRecording = !this.isRecording;
    if (this.timeElapsed < 10) {
      this.displayPopupMessage(
        "You need to record for at least 10 seconds to do a successful recording"
      );
      this.cancelRecording();
      return;
    }
    this.stopRecording();
  }

  private displayPopupMessage(str: String, success: Boolean = false) {
    this.showWarning = true;
    this.popupMessage = str;
    this.popupMessageSuccess = success;
    if (this.popupMessageTimeout) {
      window.clearTimeout(this.popupMessageTimeout);
    }
    this.popupMessageTimeout = window.setTimeout(
      () => (this.showWarning = false),
      4000
    );
  }

  private resetVars() {
    this.isRecording = false;
    this.connectionEstablished = false;
    this.setupSocketHandlers();
    this.setupRecorders();
    this.timeElapsed = 0;
  }

  // This is used if something wants to externally reset the recorder
  // when it is NOT recording
  @Watch("reset")
  private resetAndRelease() {
    console.warn("resetAndRelease called");
    //window.clearInterval(this.timer);
    this.releaseResources();
    this.resetVars();
  }

  private mounted() {
    this.setupRecorders();
  }

  private setupRecorders() {
    if (!this.recordVideo) {
      this.ar = new AudioRecorder(this.onAudioChunk);
      this.ar
        .Setup()
        .then(() => (this.havepermissions = true))
        .catch((reason) => {
          console.log(reason);
          this.havepermissions = false;
          this.fatalError(new Event("missing-av-permissions"));
        });
    }
    this.setRecordedVideoURL(null);
    this.setupSocketHandlers();
    if (this.recordVideo) {
      let vid = document.getElementById("video1") as HTMLVideoElement;
      this.vr = new VideoRecorder(vid, this.socket);
      this.vr
        .Setup()
        .then(() => (this.havepermissions = true))
        .catch((reason) => {
          console.log(reason);
          this.havepermissions = false;
          this.fatalError(new Event("missing-av-permissions"));
        });
    }
  }

  private startRecording() {
    let timeout = window.setTimeout(() => {
      if (!this.connectionEstablished) {
        this.displayPopupMessage("Connection timed out. Please try again.");
        this.cancelRecording();
      }
    }, 15000);

    let rinit = {
      Type: this.type,
      ID: this.exerciseID,
    };
    this.isRecording = !this.isRecording;
    this.socket.Init(this.JWT, rinit);

    this.socket.OnInitiator().then((x) => {
      if (this.ar) {
        this.ar.StartRecording();
      } else if (this.vr) {
        this.vr.StartRecording();
      }
      window.clearTimeout(timeout);
      this.connectionEstablished = true;
      this.startTimer();
      this.$emit("start-recording", x);
    });
  }

  private startTimer() {
    this.timeElapsed = 0;
    this.timer = setInterval(() => {
      this.timeElapsed += 1;
    }, 1000);
  }

  private onAudioChunk(blob: any) {
    if (this.connectionEstablished) {
      this.socket.SendBinary(blob);
    }
  }

  async stopRecording() {
    window.clearInterval(this.timer);
    if (this.ar) {
      this.ar.StopRecording();
    }
    this.socket.SendEndOfAudio();
    this.$emit("done-recording");
    if (this.recordVideo) {
      this.vr.StopRecording();
    }
    this.releaseResources();
  }

  cancelRecording() {
    window.clearInterval(this.timer);
    if (this.ar) {
      this.ar.StopRecording();
    } else if (this.recordVideo && this.vr) {
      this.vr.StopRecording();
    }

    if (this.socket) {
      this.socket.SendCancel();
      this.socket.Close();
    }
    this.releaseResources();
    this.resetVars();
    this.$emit("cancel-recording");
  }

  private releaseResources() {
    if (this.ar) {
      this.ar.releaseResources();
    }
    if (this.vr) {
      this.vr.releaseResources();
    }
  }

  private onResults(results: any) {
    this.$emit("final-results", results);
  }

  private destroyed() {
    if (this.ar) {
      this.ar.releaseResources();
    }
    if (this.vr) {
      this.vr.releaseResources();
    }
    this.socket.Close();
  }
}
